import d1 from './desktop/1.svg';
import d2 from './desktop/2.svg';
import d3 from './desktop/3.svg';
import d4 from './desktop/4.svg';
import d5 from './desktop/5.svg';
import d6 from './desktop/6.svg';
import d7 from './desktop/7.svg';
import d8 from './desktop/8.svg';

import m1 from './mobile/1.svg';
import m2 from './mobile/2.svg';
import m3 from './mobile/3.svg';
import m4 from './mobile/4.svg';
import m5 from './mobile/5.svg';
import m6 from './mobile/6.svg';
import m7 from './mobile/7.svg';
import m8 from './mobile/8.svg';

export const DESKTOP_IMAGES: Record<number, string> = {
  1: d1,
  2: d2,
  3: d3,
  4: d4,
  5: d5,
  6: d6,
  7: d7,
  8: d8,
};

export const MOBILE_IMAGES: Record<number, string> = {
  1: m1,
  2: m2,
  3: m3,
  4: m4,
  5: m5,
  6: m6,
  7: m7,
  8: m8,
};
